import { useSelector } from 'react-redux';
import type { DeepLinks } from '@makemydeal/dr-sales-checkin-types';
import type { SalesCheckinRootState } from '../common/types/SalesCheckinRootState';

export const useDeepLinkUrlSelector = (linkType: DeepLinks): string => {
    const url: string = useSelector((state: SalesCheckinRootState) => {
        const deepLinkUrls = state.salesCheckin.common.deeplinkUrls;
        const result = deepLinkUrls?.get(linkType);
        return result || '';
    });
    return url;
};
